import scrollLock from "scroll-lock/dist/scroll-lock";
import {FILTER_SELECTED_EVENT} from "../constants/events";
import {FiltersController} from "./filters-controller";
import CoursesMenuSection from "./courses-menu-section";

export default class CoursesMenu {
    constructor() {
        this.$triggers = document.querySelectorAll('[data-trigger="coursesMenu"]');
        this.$root = document.querySelector('.courses-menu');
        this.$closeTriggers = this.$root.querySelectorAll('[data-courses-menu="close"]');
        this.$sections = this.$root.querySelectorAll('.courses-menu-section');

        this.filters = new FiltersController(document.getElementById('coursesMenuFiltersContainer'));
        this.sections = [];

        this.init();
    }

    init() {
        this.addEventListeners();
        this.initCourseMenuSections();
    }

    addEventListeners() {
        this.$triggers.forEach($trigger => {
            $trigger.addEventListener('click', () => this.open());
        });

        this.$closeTriggers.forEach(($close) => {
            $close.addEventListener('click', () => this.close());
        });

        this.filters.$root.addEventListener(FILTER_SELECTED_EVENT, ({ detail }) => this.setFilter(detail));
    }

    open() {
        this.$root.classList.add('-show');
        scrollLock.disablePageScroll([this.$root]);
        this.filters.setFilterByValue('all');
    }

    close() {
        scrollLock.clearQueueScrollLocks();
        scrollLock.enablePageScroll(this.$root);
        this.$root.classList.remove('-show');
    }

    initCourseMenuSections() {
        this.$sections.forEach($section => {
            this.sections.push(new CoursesMenuSection($section));
        });
    }

    setFilter(category) {
        this.$sections.forEach(($section) => {
            $section.dispatchEvent(new CustomEvent(FILTER_SELECTED_EVENT, {
                detail: category
            }));
        });
    }
}